const statusPosition = {
  PENDING: 1,
  REJECT_FROM_OPERATOR: 2,
  SEND_SUGGESTION_TO_PUBLISHER: 3,
  DISAGREE_FROM_PUBLISHER: 4,
  AGREE_FROM_PUBLISHER: 5,
  CONFIRM: 6,

  ALREADY_CONFIRMED_PENDING_FOR_EDIT: 7,
  ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT: 8,
  ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT: 9,
  ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT: 10,
  ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT: 11,
};

const getStatusPositionString = () => {
  let data = {};
  data[statusPosition.PENDING] = "در حال انتظار";
  data[statusPosition.REJECT_FROM_OPERATOR] = "رد شده از طرف اپراتور";
  data[statusPosition.SEND_SUGGESTION_TO_PUBLISHER] =
    "تایید موقت و ارسال پیشنهاد به نمایش دهنده";
  data[statusPosition.DISAGREE_FROM_PUBLISHER] =
    "رد شدن پیشنهاد از طرف نمایش دهنده";
  data[statusPosition.AGREE_FROM_PUBLISHER] =
    "تایید شدن پیشنهاد از طرف نمایش دهنده";
  data[statusPosition.CONFIRM] = "تایید نهایی";

  data[statusPosition.ALREADY_CONFIRMED_PENDING_FOR_EDIT] = "تایید شده - در حال انتظار برای ویرایش";
  data[statusPosition.ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT] = "تایید شده - رد شده از طرف اپراتور برای ویرایش";
  data[statusPosition.ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT] = "تایید شده - تایید موقت و ارسال پیشنهاد به نمایش دهنده برای ویرایش";
  data[statusPosition.ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT] = "تایید شده -   رد شدن پیشنهاد از طرف نمایش دهنده برای ویرایش";
  data[statusPosition.ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT] = "تایید شده -   تایید شدن پیشنهاد از طرف نمایش دهنده برای ویرایش";

  return data;
};

export default {
  statusPosition,
  getStatusPositionString,
};
